import { useTranslations } from 'next-intl';
import { useClientAccount } from 'providers/ClientProviders/useClientAccount';
import { Option } from 'types/Option';

interface IUseOptionsQualityIn {
  noAny?: boolean;
}
interface IUseOptionsQualityOut {
  optionsQuality: Option[];
}

export default function useOptionsQuality(
  { noAny }: IUseOptionsQualityIn = { noAny: false }
): IUseOptionsQualityOut {
  const t = useTranslations();

  const { data } = useClientAccount();

  const optionsQualityInital = noAny
    ? []
    : [{ label: t('ordering_form.qualities.any'), value: undefined }];

  const optionsQuality =
    data?.orderableQualities?.reduce(
      (acc, quality) => [
        ...acc,
        { label: t(`ordering_form.qualities.${quality}` as any), value: quality }
      ],
      optionsQualityInital as Option[]
    ) ?? optionsQualityInital;

  return { optionsQuality };
}
